import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=df8724e8&scoped=true"
import script from "./InputSelect.vue?vue&type=script&lang=ts"
export * from "./InputSelect.vue?vue&type=script&lang=ts"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=df8724e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8724e8",
  null
  
)

export default component.exports